import React, { useMemo } from 'react';

import { TableCell, TableRow, TableRowActionsMenu } from '@occc/ui-design-system';

import { CampaignWithComponentTableRow } from './CampaignWithComponentTableRow';
import { CampaignWithCampaignComponentsSanitized } from '../types';

type CampaignTableRowProps = {
  campaign: CampaignWithCampaignComponentsSanitized;
  onItemClick: (campaignId: string) => void;
  onEdit: (campaignId: string) => void;
  showOffers?: boolean;
  isUserPermittedToEditCampaign: boolean;
  isUserPermittedToEditCampaignComponent: boolean;
  isUserPermittedToDeleteCampaignComponent: boolean;
};

export const CampaignTableRow = ({
  campaign,
  onItemClick,
  onEdit,
  showOffers,
  isUserPermittedToEditCampaign,
  isUserPermittedToEditCampaignComponent,
  isUserPermittedToDeleteCampaignComponent,
}: CampaignTableRowProps) => {
  const { uuid, name, description, category, externalId } = campaign;
  const onRowClick = () => {
    onItemClick(uuid);
  };

  const menuItems = useMemo(() => {
    return [
      {
        label: 'Edit Campaign',
        onClick: () => onEdit(uuid),
        dataTestId: 'edit',
      },
    ];
  }, [onEdit, uuid]);

  const isTableRowActionsMenuVisible = isUserPermittedToEditCampaign && !campaign.deleted;

  return (
    <>
      <TableRow onClick={onRowClick}>
        <TableCell>{name || ''}</TableCell>
        <TableCell>{description || ''}</TableCell>
        <TableCell>{category || ''}</TableCell>
        <TableCell>{externalId || ''}</TableCell>
        {isTableRowActionsMenuVisible && (
          <TableCell padding='button' align='right'>
            <TableRowActionsMenu menuItems={menuItems} />
          </TableCell>
        )}
      </TableRow>
      {showOffers && campaign.campaignComponents ? (
        <CampaignWithComponentTableRow
          campaign={campaign}
          isUserPermittedToEditCampaignComponent={isUserPermittedToEditCampaignComponent}
          isUserPermittedToDeleteCampaignComponent={isUserPermittedToDeleteCampaignComponent}
        />
      ) : null}
    </>
  );
};
